import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@bingads-webui-campaign-react/router';

import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';

// component help refresh the page on route change and we have a new version deployed.
class NewVersionReloaderInternal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldReload: false,
    };
  }

  componentDidMount = () => {
    eventDispatcher.on('new-version-available', () => {
      this.setState({
        shouldReload: true,
      });
    });
  }

  componentDidUpdate = (prevProps) => {
    if ((this.props.location.pathname !== prevProps.location.pathname) && this.state.shouldReload) {
      this.fullPageRefresh();
    }
  };

  fullPageRefresh = () => {
    window.location.reload();

    this.setState({
      shouldReload: false,
    });
  }

  render() {
    return null;
  }
}


NewVersionReloaderInternal.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};


export const NewVersionReloader = withRouter(NewVersionReloaderInternal);

